import { render, staticRenderFns } from "./veHqChuruku.vue?vue&type=template&id=4bf76ac4&scoped=true"
import script from "./veHqChuruku.vue?vue&type=script&lang=js"
export * from "./veHqChuruku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf76ac4",
  null
  
)

export default component.exports